import {
  constructCallableReference23y65rf941mch as constructCallableReference,
  getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { lazy2hsh8ze7j6ikd as lazy } from '../../../../kotlin-kotlin-stdlib/kotlin/kotlin.mjs';
import { KProperty1ca4yb4wlo496 as KProperty1 } from '../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import { toString1pkumu07cwy4m as toString } from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function stringSerializer(deserializationStrategy) {
  return new (stringSerializer$1())(deserializationStrategy);
}
function stringSerializer$o$_get_descriptor_$ref_wan83j() {
  return constructCallableReference((p0) => p0.get_descriptor_wjt6a0_k$(), 1, 0, 18);
}
var stringSerializer$1Class;
function stringSerializer$1() {
  if (stringSerializer$1Class === VOID) {
    class $ {
      constructor($deserializationStrategy) {
        this.$deserializationStrategy_1 = $deserializationStrategy;
        var tmp = this;
        tmp.descriptor$delegate_1 = lazy(() => $deserializationStrategy.get_descriptor_wjt6a0_k$());
      }
      get_descriptor_wjt6a0_k$() {
        var tmp0 = this.descriptor$delegate_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('descriptor', 1, tmp, stringSerializer$o$_get_descriptor_$ref_wan83j(), null);
        return tmp0.get_value_j01efc_k$();
      }
      serialize_kj9hv3_k$(encoder, value) {
        return encoder.encodeString_424b5v_k$(toString(value));
      }
      serialize_5ase3y_k$(encoder, value) {
        return this.serialize_kj9hv3_k$(encoder, !(value == null) ? value : THROW_CCE());
      }
      deserialize_sy6x50_k$(decoder) {
        return this.$deserializationStrategy_1.deserialize_sy6x50_k$(decoder);
      }
    }
    initMetadataForClass($, VOID, VOID, VOID, [KSerializer()]);
    stringSerializer$1Class = $;
  }
  return stringSerializer$1Class;
}
//region block: exports
export {
  stringSerializer as stringSerializer3fqetsvttr56r,
};
//endregion

//# sourceMappingURL=Serializers.mjs.map
